import { ServerInfoCallback } from '@protos/v2/serverinfo';
import { streamV2ServerInfo } from '@services/context';
import { useEffect, useRef } from 'react';

export const useStreamV2ServerInfo = (callback: ServerInfoCallback, isReadyToProcessMessages: boolean) => {
  const target = useRef<ServerInfoCallback>(callback);

  useEffect(() => {
    if (!isReadyToProcessMessages) return;

    target.current = callback;
    streamV2ServerInfo.subscribe(callback);

    return () => {
      streamV2ServerInfo.unsubscribe(callback);
    };
  }, [isReadyToProcessMessages, callback]);
};
